// extracted by mini-css-extract-plugin
export default {"modalWrap":"modal_modalWrap__Y7JIw"};